import { useEffect, useRef, useState } from "react";
import { PreservativesViewModel } from "../../../viewmodels/setup/preservatives/PreservativesViewModel";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import { withRouter } from "../../../shared/utility";
import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import { auditHistoriesSetupAction } from "../../../components/audit/auditEntityConfig";

function Preservatives(props) {
  const { addSnackbar, logout } = props;
  const {
    emptyModal,
    setEmptyModelOpen,
    getPreservatives,
    loading,
    preservatives,
    openAddPreservativeSlideOver,
    setSlideOver,
    slideOver,
    viewPreservativeDetails,
    askDeletePreservative,
  } = PreservativesViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    getPreservatives(null, currentPage);
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const searchRef = useRef();

  const handleSearch = () => {
    getPreservatives(searchRef.current.value, currentPage);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getPreservatives(searchRef.current.value, currentPage);
  };

  return (
    <div>
      <SetupPage
        title="Preservatives"
        description="Manage preservative options used in item and product setup."
        searchPlaceholder="Search preservatives"
        searchRef={searchRef}
        onSearch={handleSearch}
        actions={[
          { label: "Add Preservative", onClick: openAddPreservativeSlideOver },
          auditHistoriesSetupAction("preservative"),
        ]}
        loading={loading}
        tableColumns={["Name"]}
        totalRecords={preservatives.total}
        first={first}
        rows={rows}
        onPageChange={handlePagination}
      >
        <SetupTable columns={["Name"]} emptyText="No preservatives found.">
          {preservatives.data?.map((item, index) => (
            <tr key={item.id} className="transition hover:bg-[#F6F8FB]/80">
              <SetupTd muted={false}>{item.name}</SetupTd>
              <SetupActions>
                <button
                  type="button"
                  onClick={() => viewPreservativeDetails(item, index)}
                  className="inline-flex min-w-[68px] justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
                >
                  Edit
                </button>
                <AuditActionLink
                  slug="preservative"
                  id={item.id}
                  name={item.name}
                  className="ml-2"
                />
                <button
                  type="button"
                  onClick={() => askDeletePreservative(item, index)}
                  className="ml-2 inline-flex min-w-[68px] justify-center rounded-lg border border-[#FECACA] bg-white px-3 py-1.5 text-sm font-semibold text-[#DC2626] shadow-sm transition hover:border-[#FCA5A5] hover:bg-[#FEF2F2]"
                >
                  Delete
                </button>
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Preservatives),
);
